import { UxReviewPanel } from '../../../features/exploratory-tests/components/UxReviewPanel';
import type { ExploratoryBrowserSession, ReviewFinding, UxReviewReportJson } from '../../../features/exploratory-tests/types';

type UxReviewSidebarProps = {
  report: UxReviewReportJson | null;
  findings: ReviewFinding[];
  runId: string;
  sessions: ExploratoryBrowserSession[];
  onSelectSession: (id: string) => void;
};

export function UxReviewSidebar({ report, findings, runId, sessions, onSelectSession }: UxReviewSidebarProps) {
  return (
    <div className="w-[380px] shrink-0 flex flex-col border-l border-border bg-card">
      <UxReviewPanel report={report} findings={findings} runId={runId}
        sessions={sessions}
        onSelectSession={onSelectSession}
      />
    </div>
  );
}
